import Cookies from 'js-cookie';
import partners from '$data/Partners';

export function safeCheckPartnerNameFromCookie(): JSON | undefined {
  const partnerCookie = Cookies.getJSON('fixterPartner');
  if (!partnerCookie || !partners) return undefined;
  const isPartner = partners.find(({ slug }) => slug === partnerCookie);
  if (!isPartner) return undefined;
  return partnerCookie;
}

export function safeCheckPostcodeFromCookie(): string {
  const postcodeCookie = Cookies.get('fixterPostcode') ?? '';
  return postcodeCookie?.replace(/[\W_]+/g, '')?.toUpperCase();
}
